import classNames from 'classnames';
import { useContext, useEffect, useState } from 'react';

import i18n from '@nextroll/ar-i18n';

// assets
// @ts-ignore - no types for an image.
import confettiSvgAdRoll from '../../assets/email-verification/confetti-adroll.svg';
// @ts-ignore - no types for an image.
import confettiSvgRollWorks from '../../assets/email-verification/confetti-rollworks.svg';
// @ts-ignore - no types for an image.
import emailImgAdRoll from '../../assets/email-verification/email-adroll.png';
// @ts-ignore - no types for an image.
import emailImgRollWorks from '../../assets/email-verification/email-rollworks.png';
// @ts-ignore - no types for an image.
import errorImg from '../../assets/email-verification/error.png';
import { BU_ADROLL, BU_ROLLWORKS } from '../../constants';
import ThemeWrapperContext from '../../contexts/ThemeWrapperContext';

const errorImgSrc = `${process.env.STATIC_PATH}${errorImg}`;

const imgSrc = {
    [BU_ROLLWORKS]: {
        mainImg: emailImgRollWorks,
        confettiImg: confettiSvgRollWorks,
    },
    [BU_ADROLL]: {
        mainImg: emailImgAdRoll,
        confettiImg: confettiSvgAdRoll,
    },
};

const delays = {
    [BU_ROLLWORKS]: 500,
    [BU_ADROLL]: 200,
};

interface IProps {
    animate?: boolean;
    bottomText?: string;
    children?: React.ReactNode;
    className?: string;
    error?: boolean;
    topText?: string;
}

const PageBanner = ({
    animate,
    bottomText,
    children,
    className,
    error,
    topText,
}: IProps) => {
    const [animateClass, setAnimateClass] = useState(false);

    const { businessUnit } = useContext(ThemeWrapperContext);
    const mainImgSrc = `${process.env.STATIC_PATH}${imgSrc[businessUnit].mainImg}`;
    const confettiImgSrc = `${process.env.STATIC_PATH}${imgSrc[businessUnit].confettiImg}`;

    useEffect(() => {
        const timer = window.setTimeout(() => {
            setAnimateClass(true);
        }, delays[businessUnit]);
        return () => {
            window.clearTimeout(timer);
        };
    }, [animate, businessUnit]);

    return (
        <div
            className={classNames(
                'eh-ev-page-banner',
                className,
                animateClass && 'animate'
            )}
        >
            <div className='eh-ev-page-banner-image'>
                {animate && (
                    <div className='confetti'>
                        <img
                            src={confettiImgSrc}
                            alt={i18n.gettext('Confetti')}
                        />
                    </div>
                )}
                <img
                    src={error ? errorImgSrc : mainImgSrc}
                    className='eh-ev-page-banner-image-email-img'
                    alt={i18n.gettext('Email Verification at NextRoll')}
                />
            </div>
            <div className='eh-ev-page-banner-text'>
                {topText && (
                    <h1 className='eh-ev-page-banner-text-top'>{topText}</h1>
                )}
                {bottomText && (
                    <div className='eh-ev-page-banner-text-bottom'>
                        {bottomText}
                    </div>
                )}
            </div>
            <div className='eh-ev-page-banner-children'>{children}</div>
        </div>
    );
};

export default PageBanner;
